(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["book-trip"] && !Shopify.designMode) return;
  try {
    
(function(){
  var params = new URLSearchParams(window.location.search);
  var variantId = params.get('variant');
  var title = params.get('title') || '';
  var onewayCents = parseInt(params.get('oneway') || '0', 10);
  var roundtripCents = parseInt(params.get('roundtrip') || '0', 10);

  var titleEl = document.getElementById('ff-book-title');
  var missingEl = document.getElementById('ff-book-missing');
  var formEl = document.getElementById('ff-book-form');

  if(!variantId || !title){
    if(titleEl) titleEl.textContent = 'Fare not found';
    if(missingEl) missingEl.hidden = false;
    return;
  }

  if(titleEl) titleEl.textContent = title;
  if(formEl) formEl.hidden = false;
  var sumRoute = document.getElementById('ff-book-sum-route');
  if(sumRoute) sumRoute.textContent = title;

  if(roundtripCents > 0){
    var rtTab = document.getElementById('ff-book-rt-tab');
    if(rtTab) rtTab.hidden = false;
  }

  var state = { trip: 'oneway', adults: 1, children: 0, bags: 0, cabin: 'Economy' };

  function money(cents){
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  function renderPassengerFields(){
    var total = state.adults + state.children;
    var wrap = document.getElementById('ff-passenger-list');
    if(!wrap) return;

    var existing = wrap.querySelectorAll('.ff-book__passenger input');
    var existingValues = [];
    existing.forEach(function(input){ existingValues.push(input.value); });

    wrap.innerHTML = '';
    for(var i = 0; i < total; i++){
      var isChild = i >= state.adults;
      var div = document.createElement('div');
      div.className = 'ff-book__passenger';
      var h4 = document.createElement('h4');
      h4.textContent = 'Passenger ' + (i + 1) + (isChild ? ' (Child)' : ' (Adult)');
      var input = document.createElement('input');
      input.type = 'text';
      input.placeholder = 'Full name as on ID';
      input.setAttribute('data-passenger-index', i);
      input.required = true;
      if(existingValues[i]) input.value = existingValues[i];
      div.appendChild(h4);
      div.appendChild(input);
      wrap.appendChild(div);
    }
  }

  function updateSummary(){
    var fareCents = state.trip === 'roundtrip' ? roundtripCents : onewayCents;
    var totalPax = state.adults + state.children;
    var total = fareCents * totalPax;
    var paxEl = document.getElementById('ff-book-sum-pax');
    var totalEl = document.getElementById('ff-book-sum-total');
    if(paxEl) paxEl.textContent = totalPax;
    if(totalEl) totalEl.textContent = money(total);
    var returnField = document.getElementById('ff-book-return-field');
    if(returnField) returnField.hidden = state.trip !== 'roundtrip';
  }

  document.querySelectorAll('.ff-book__triptab').forEach(function(tab){
    tab.addEventListener('click', function(){
      document.querySelectorAll('.ff-book__triptab').forEach(function(t){ t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      state.trip = tab.dataset.trip;
      updateSummary();
    });
  });

  document.querySelectorAll('.ff-book__optbtn').forEach(function(btn){
    btn.addEventListener('click', function(){
      document.querySelectorAll('.ff-book__optbtn').forEach(function(b){ b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      state.cabin = btn.dataset.cabin;
    });
  });

  document.querySelectorAll('[data-step]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var dir = parseInt(btn.dataset.dir, 10);
      var field = btn.dataset.step;
      if(field === 'adults'){
        state.adults = Math.max(1, Math.min(9, state.adults + dir));
        document.getElementById('ff-book-adults').value = state.adults;
      }
      if(field === 'children'){
        state.children = Math.max(0, Math.min(8, state.children + dir));
        document.getElementById('ff-book-children').value = state.children;
      }
      if(field === 'bags'){
        state.bags = Math.max(0, Math.min(3, state.bags + dir));
        document.getElementById('ff-book-bags').value = state.bags;
      }
      if(field === 'adults' || field === 'children'){
        renderPassengerFields();
      }
      updateSummary();
    });
  });

  var departInput = document.getElementById('ff-book-depart');
  var returnInput = document.getElementById('ff-book-return');
  var todayISO = new Date().toISOString().split('T')[0];
  departInput.min = todayISO;
  returnInput.min = todayISO;
  departInput.addEventListener('change', function(){ returnInput.min = departInput.value; });

  renderPassengerFields();
  updateSummary();

  var formElement = document.getElementById('ff-book-form');
  formElement.addEventListener('submit', function(e){
    e.preventDefault();
    var submitBtn = document.getElementById('ff-book-submit');
    var valid = true;

    if(!departInput.value){ departInput.classList.add('is-invalid'); valid = false; } else { departInput.classList.remove('is-invalid'); }
    if(state.trip === 'roundtrip' && !returnInput.value){ returnInput.classList.add('is-invalid'); valid = false; } else { returnInput.classList.remove('is-invalid'); }

    var passengerInputs = document.querySelectorAll('[data-passenger-index]');
    var passengerNames = [];
    passengerInputs.forEach(function(input){
      if(!input.value.trim()){ input.classList.add('is-invalid'); valid = false; }
      else { input.classList.remove('is-invalid'); }
      passengerNames.push(input.value.trim());
    });

    var emailInput = document.getElementById('ff-book-email');
    var phoneInput = document.getElementById('ff-book-phone');
    if(!emailInput.value.trim()){ emailInput.classList.add('is-invalid'); valid = false; } else { emailInput.classList.remove('is-invalid'); }
    if(!phoneInput.value.trim()){ phoneInput.classList.add('is-invalid'); valid = false; } else { phoneInput.classList.remove('is-invalid'); }

    if(!valid){
      var firstInvalid = formElement.querySelector('.is-invalid');
      if(firstInvalid) firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Adding to cart…';

    // Send a real notification email via Shopify's native contact form
    var summaryLines = [
      'New booking request',
      'Route: ' + title,
      'Trip type: ' + (state.trip === 'roundtrip' ? 'Round trip' : 'One-way'),
      'Departure date: ' + departInput.value
    ];
    if(state.trip === 'roundtrip') summaryLines.push('Return date: ' + returnInput.value);
    summaryLines.push('Adults: ' + state.adults, 'Children: ' + state.children);
    summaryLines.push('Cabin class: ' + state.cabin, 'Checked bags: ' + state.bags);
    passengerNames.forEach(function(name, i){
      summaryLines.push('Passenger ' + (i + 1) + ': ' + name);
    });
    summaryLines.push('Phone: ' + phoneInput.value.trim());

    var contactBody = new URLSearchParams();
    contactBody.set('form_type', 'contact');
    contactBody.set('utf8', '✓');
    contactBody.set('contact[name]', passengerNames[0] || 'Farflung customer');
    contactBody.set('contact[email]', emailInput.value.trim());
    contactBody.set('contact[phone]', phoneInput.value.trim());
    contactBody.set('contact[body]', summaryLines.join('\n'));

    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: contactBody.toString()
    }).catch(function(){ /* non-blocking */ });

    var properties = {
      'Trip type': state.trip === 'roundtrip' ? 'Round trip' : 'One-way',
      'Departure date': departInput.value,
      'Adults': state.adults,
      'Children': state.children,
      'Cabin class': state.cabin,
      'Checked bags': state.bags,
      'Email': emailInput.value.trim(),
      'Phone': phoneInput.value.trim()
    };
    if(state.trip === 'roundtrip') properties['Return date'] = returnInput.value;
    passengerNames.forEach(function(name, i){
      properties['Passenger ' + (i + 1)] = name;
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: parseInt(variantId, 10),
          quantity: state.adults + state.children,
          properties: properties
        }]
      })
    })
    .then(function(res){
      if(!res.ok) throw new Error('add to cart failed');
      return res.json();
    })
    .then(function(){
      window.location.href = '/checkout';
    })
    .catch(function(){
      submitBtn.disabled = false;
      submitBtn.textContent = 'Continue to checkout';
      alert('Something went wrong adding this to your cart. Please try again.');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-custom"] && !Shopify.designMode) return;
  try {
    
(function(){
  var itemsWrap = document.getElementById('ff-cart-items');
  if(!itemsWrap) return;

  function money(cents, currency){
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: currency || 'USD' });
  }

  function refreshFromCart(cart){
    var subtotalEl = document.getElementById('ff-cart-subtotal');
    if(subtotalEl) subtotalEl.textContent = money(cart.total_price, (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD');
    if(cart.item_count === 0){ window.location.reload(); }
  }

  function changeLine(key, quantity){
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(res){ return res.json(); })
    .then(function(cart){ refreshFromCart(cart); })
    .catch(function(){ window.location.reload(); });
  }

  itemsWrap.addEventListener('click', function(e){
    var qtyBtn = e.target.closest('.ff-cart__qtybtn');
    if(qtyBtn){
      var itemEl = qtyBtn.closest('.ff-cart__item');
      var qtyEl = itemEl.querySelector('.ff-cart__qtyval');
      var current = parseInt(qtyEl.textContent, 10);
      var next = Math.max(0, current + parseInt(qtyBtn.dataset.qtyDir, 10));
      if(next === 0){ itemEl.style.opacity = '0.4'; } else { qtyEl.textContent = next; }
      changeLine(itemEl.dataset.key, next);
      if(next === 0) itemEl.remove();
      return;
    }
    var removeBtn = e.target.closest('.ff-cart__remove');
    if(removeBtn){
      var itemEl2 = removeBtn.closest('.ff-cart__item');
      itemEl2.style.opacity = '0.4';
      changeLine(removeBtn.dataset.removeKey, 0);
      itemEl2.remove();
    }
  });

  var applyBtn = document.getElementById('ff-cart-apply-discount');
  var discountInput = document.getElementById('ff-cart-discount');
  var checkoutBtn = document.getElementById('ff-cart-checkout');
  if(applyBtn && discountInput && checkoutBtn){
    applyBtn.addEventListener('click', function(){
      var code = discountInput.value.trim();
      if(code){
        checkoutBtn.href = '/checkout?discount=' + encodeURIComponent(code);
        applyBtn.textContent = 'Applied ✓';
        setTimeout(function(){ applyBtn.textContent = 'Apply'; }, 1800);
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function(){
  var toggle = document.getElementById('ff-menu-toggle');
  var closeBtn = document.getElementById('ff-drawer-close');
  var drawer = document.getElementById('ff-mobile-drawer');
  var scrim = document.getElementById('ff-menu-scrim');
  if(!toggle || !drawer || !scrim) return;

  function openMenu(){
    drawer.classList.add('is-open');
    scrim.hidden = false;
    requestAnimationFrame(function(){ scrim.classList.add('is-open'); });
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu(){
    drawer.classList.remove('is-open');
    scrim.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(function(){ scrim.hidden = true; }, 250);
  }

  toggle.addEventListener('click', openMenu);
  if(closeBtn) closeBtn.addEventListener('click', closeMenu);
  scrim.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closeMenu();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var US_AIRPORTS = [
    {code:"ATL", city:"Atlanta, GA"}, {code:"LAX", city:"Los Angeles, CA"}, {code:"ORD", city:"Chicago, IL"},
    {code:"DFW", city:"Dallas, TX"}, {code:"DEN", city:"Denver, CO"}, {code:"JFK", city:"New York, NY"},
    {code:"LGA", city:"New York, NY"}, {code:"SFO", city:"San Francisco, CA"}, {code:"SEA", city:"Seattle, WA"},
    {code:"LAS", city:"Las Vegas, NV"}, {code:"MCO", city:"Orlando, FL"}, {code:"MIA", city:"Miami, FL"},
    {code:"PHX", city:"Phoenix, AZ"}, {code:"IAH", city:"Houston, TX"}, {code:"BOS", city:"Boston, MA"},
    {code:"MSP", city:"Minneapolis, MN"}, {code:"DTW", city:"Detroit, MI"}, {code:"FLL", city:"Fort Lauderdale, FL"},
    {code:"PHL", city:"Philadelphia, PA"}, {code:"BWI", city:"Baltimore, MD"},
    {code:"SLC", city:"Salt Lake City, UT"}, {code:"SAN", city:"San Diego, CA"}, {code:"TPA", city:"Tampa, FL"},
    {code:"AUS", city:"Austin, TX"}, {code:"BNA", city:"Nashville, TN"}, {code:"MDW", city:"Chicago, IL"},
    {code:"HNL", city:"Honolulu, HI"}, {code:"DCA", city:"Washington, DC"}, {code:"IAD", city:"Washington, DC"},
    {code:"PDX", city:"Portland, OR"}, {code:"STL", city:"St. Louis, MO"}, {code:"RDU", city:"Raleigh, NC"},
    {code:"MCI", city:"Kansas City, MO"}, {code:"SJC", city:"San Jose, CA"}, {code:"SNA", city:"Orange County, CA"},
    {code:"CLE", city:"Cleveland, OH"}, {code:"PIT", city:"Pittsburgh, PA"}, {code:"CVG", city:"Cincinnati, OH"},
    {code:"IND", city:"Indianapolis, IN"}, {code:"CMH", city:"Columbus, OH"}, {code:"MKE", city:"Milwaukee, WI"},
    {code:"OMA", city:"Omaha, NE"}, {code:"OKC", city:"Oklahoma City, OK"}, {code:"TUL", city:"Tulsa, OK"},
    {code:"MEM", city:"Memphis, TN"}, {code:"RSW", city:"Fort Myers, FL"}, {code:"PGD", city:"Punta Gorda, FL"},
    {code:"VPS", city:"Destin, FL"}, {code:"GRR", city:"Grand Rapids, MI"}, {code:"FNT", city:"Flint, MI"},
    {code:"MFE", city:"McAllen, TX"}, {code:"BLI", city:"Bellingham, WA"}, {code:"BLV", city:"St. Louis (Belleville), IL"},
    {code:"ANC", city:"Anchorage, AK"}, {code:"ABQ", city:"Albuquerque, NM"}, {code:"BUF", city:"Buffalo, NY"},
    {code:"BUR", city:"Burbank, CA"}, {code:"CHS", city:"Charleston, SC"}, {code:"CLT", city:"Charlotte, NC"},
    {code:"COS", city:"Colorado Springs, CO"}, {code:"DAL", city:"Dallas (Love Field), TX"}, {code:"ELP", city:"El Paso, TX"},
    {code:"GEG", city:"Spokane, WA"}, {code:"GSP", city:"Greenville, SC"}, {code:"JAX", city:"Jacksonville, FL"},
    {code:"MSY", city:"New Orleans, LA"}, {code:"ONT", city:"Ontario, CA"}, {code:"PBI", city:"West Palm Beach, FL"},
    {code:"RIC", city:"Richmond, VA"}, {code:"ROC", city:"Rochester, NY"}, {code:"SAT", city:"San Antonio, TX"},
    {code:"SDF", city:"Louisville, KY"}, {code:"SMF", city:"Sacramento, CA"}, {code:"SYR", city:"Syracuse, NY"},
    {code:"TUS", city:"Tucson, AZ"}, {code:"XNA", city:"Northwest Arkansas"}
  ];
  var PIN_ICON = '<svg class="ff-hero__suggest-icon" width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C7.6 2 4 5.6 4 10c0 6 8 12 8 12s8-6 8-12c0-4.4-3.6-8-8-8zm0 11a3 3 0 110-6 3 3 0 010 6z"/></svg>';

  function findAirport(rawValue){
    var val = (rawValue || '').trim().toLowerCase();
    if(!val) return null;
    var codeMatch = val.match(/\(([a-z]{3})\)/i);
    if(codeMatch){
      var byCode = US_AIRPORTS.find(function(a){ return a.code.toLowerCase() === codeMatch[1].toLowerCase(); });
      if(byCode) return byCode;
    }
    return US_AIRPORTS.find(function(a){
      return a.city.toLowerCase() === val || (a.city.toLowerCase() + ' (' + a.code.toLowerCase() + ')') === val;
    }) || null;
  }

  // search terms for an airport: code + city name (without state)
  function termsFor(a){
    if(!a) return [];
    var cityOnly = a.city.split(',')[0].toLowerCase().trim();
    return [a.code.toLowerCase(), cityOnly];
  }

  function escapeHtml(s){
    return (s || '').replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  function buildSuggest(input, dropdown, errorEl){
    input.addEventListener('input', function(){
      if(errorEl) errorEl.hidden = true;
      var q = input.value.trim().toLowerCase();
      dropdown.innerHTML = '';
      if(q.length < 1){ dropdown.hidden = true; return; }
      var matches = US_AIRPORTS.filter(function(a){
        return a.code.toLowerCase().indexOf(q) === 0 || a.city.toLowerCase().indexOf(q) !== -1;
      }).slice(0, 8);
      if(matches.length === 0){ dropdown.hidden = true; return; }
      matches.forEach(function(a){
        var item = document.createElement('div');
        item.className = 'ff-hero__suggest-item';
        item.innerHTML = PIN_ICON + '<span class="ff-hero__suggest-text"><b>' + a.city + '</b><span>' + a.code + '</span></span>';
        item.addEventListener('mousedown', function(e){
          e.preventDefault();
          input.value = a.city + ' (' + a.code + ')';
          dropdown.hidden = true;
        });
        dropdown.appendChild(item);
      });
      dropdown.hidden = false;
    });
    input.addEventListener('blur', function(){
      setTimeout(function(){ dropdown.hidden = true; }, 150);
    });
  }

  document.querySelectorAll('.ff-hero').forEach(function(hero){
    var slides = hero.querySelectorAll('.ff-hero__slide');
    var dots = hero.querySelectorAll('.ff-hero__dot');
    if(slides.length > 1){
      var current = 0, timer;
      function show(index){
        slides[current].classList.remove('is-active');
        if(dots[current]) dots[current].classList.remove('is-active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        if(dots[current]) dots[current].classList.add('is-active');
      }
      function startAutoplay(){ clearInterval(timer); timer = setInterval(function(){ show(current + 1); }, 6000); }
      dots.forEach(function(dot, i){ dot.addEventListener('click', function(){ show(i); startAutoplay(); }); });
      startAutoplay();
    }

    var fromInput = hero.querySelector('#ff-from-input');
    var toInput = hero.querySelector('#ff-to-input');
    var fromSuggest = hero.querySelector('#ff-from-suggest');
    var toSuggest = hero.querySelector('#ff-to-suggest');
    var fromError = hero.querySelector('#ff-from-error');
    var toError = hero.querySelector('#ff-to-error');
    var resultsEl = hero.querySelector('#ff-hero-results');
    var seeAllEl = hero.querySelector('#ff-hero-seeall');
    var seeAllUrl = seeAllEl ? seeAllEl.getAttribute('href') : '/pages/flight-tickets';

    buildSuggest(fromInput, fromSuggest, fromError);
    buildSuggest(toInput, toSuggest, toError);

    // load ticket product data
    var tickets = [];
    var dataEl = hero.querySelector('.ff-tickets-data');
    if(dataEl){
      try { tickets = JSON.parse(dataEl.textContent || '[]'); } catch(e){ tickets = []; }
    }

    var swapBtn = hero.querySelector('#ff-swap-btn');
    if(swapBtn) swapBtn.addEventListener('click', function(){
      var tmp = fromInput.value; fromInput.value = toInput.value; toInput.value = tmp;
    });

    function renderResults(fromA, toA){
      var fromTerms = termsFor(fromA);
      var toTerms = termsFor(toA);

      var matches = tickets.filter(function(t){
        var hay = ((t.title || '') + ' ' + (t.tags || '') + ' ' + (t.handle || '')).toLowerCase();
        var hasFrom = fromTerms.length === 0 || fromTerms.some(function(x){ return hay.indexOf(x) > -1; });
        var hasTo   = toTerms.length === 0   || toTerms.some(function(x){ return hay.indexOf(x) > -1; });
        return hasFrom && hasTo;
      });

      var routeLabel = '';
      if(fromA && toA) routeLabel = fromA.code + ' \u2192 ' + toA.code;

      if(matches.length === 0){
        resultsEl.innerHTML = '<div class="ff-hero__empty">No tickets found for ' +
          (routeLabel || 'this route') + '.<br><a href="' + seeAllUrl + '">Browse all flights \u2192</a></div>';
        resultsEl.hidden = false;
        return;
      }

      resultsEl.innerHTML = matches.map(function(t){
        var thumb = t.image
          ? '<div class="ff-hero__ticket-thumb" style="background-image:url(' + t.image + ')"></div>'
          : '<div class="ff-hero__ticket-thumb"></div>';
        return '<a class="ff-hero__ticket" href="' + t.url + '">' +
                 thumb +
                 '<div class="ff-hero__ticket-info">' +
                   '<div class="ff-hero__ticket-route">' + (routeLabel || escapeHtml(t.title)) + '</div>' +
                   '<div class="ff-hero__ticket-title">' + escapeHtml(t.title) + '</div>' +
                 '</div>' +
                 '<div class="ff-hero__ticket-price">' + (t.price || '') + '</div>' +
               '</a>';
      }).join('');
      resultsEl.hidden = false;
    }

    var searchBtn = hero.querySelector('#ff-search-btn');
    if(searchBtn) searchBtn.addEventListener('click', function(){
      var fromAirport = findAirport(fromInput.value);
      var toAirport = findAirport(toInput.value);
      var valid = true;

      if(fromInput.value.trim() && !fromAirport){ fromError.hidden = false; valid = false; } else if(fromError){ fromError.hidden = true; }
      if(toInput.value.trim() && !toAirport){ toError.hidden = false; valid = false; } else if(toError){ toError.hidden = true; }

      if(!valid){ if(resultsEl){ resultsEl.hidden = true; } return; }

      renderResults(fromAirport, toAirport);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tickets"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.ff-results__slider').forEach(function(slider){
    var slides = slider.querySelectorAll('.ff-results__slide');
    var dots = slider.querySelectorAll('.ff-results__dot');
    if(slides.length < 2) return;
    var current = 0, timer;
    function show(index){
      slides[current].classList.remove('is-active');
      if(dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if(dots[current]) dots[current].classList.add('is-active');
    }
    function startAutoplay(){ clearInterval(timer); timer = setInterval(function(){ show(current + 1); }, 5000); }
    dots.forEach(function(dot, i){ dot.addEventListener('click', function(){ show(i); startAutoplay(); }); });
    startAutoplay();
  });

  var list = document.getElementById('ff-results-list');
  if(!list) return;
  var cards = list.querySelectorAll('.ff-ticketcard');
  var stopBoxes = document.querySelectorAll('[data-filter-stop]');
  var fareBoxes = document.querySelectorAll('[data-filter-fare]');
  var countEl = document.getElementById('ff-results-count');
  var searchInput = document.getElementById('ff-results-search');

  function apply(){
    var activeStops = Array.from(stopBoxes).filter(b => b.checked).map(b => b.dataset.filterStop);
    var activeFares = Array.from(fareBoxes).filter(b => b.checked).map(b => b.dataset.filterFare);
    var query = searchInput ? searchInput.value.trim().toLowerCase() : '';
    var visible = 0;
    cards.forEach(function(card){
      var stopOk = activeStops.indexOf(card.dataset.stop) !== -1;
      var fareOk = activeFares.indexOf(card.dataset.fare) !== -1;
      var queryWords = query.split(/\s+/).filter(Boolean); var searchOk = queryWords.length === 0 || queryWords.every(function(w){ return card.dataset.search.indexOf(w) !== -1; });
      var show = stopOk && fareOk && searchOk;
      card.classList.toggle('is-hidden', !show);
      if(show) visible++;
    });
    if(countEl) countEl.textContent = visible + ' fare' + (visible === 1 ? '' : 's') + ' found';
  }

  stopBoxes.forEach(function(b){ b.addEventListener('change', apply); });
  fareBoxes.forEach(function(b){ b.addEventListener('change', apply); });
  if(searchInput) searchInput.addEventListener('input', apply);

  var urlParams = new URLSearchParams(window.location.search);
  var qParam = urlParams.get('q');
  if(qParam && searchInput){
    searchInput.value = qParam;
    var noteEl = document.getElementById('ff-results-note');
    if(noteEl){
      noteEl.textContent = 'No exact match for "' + qParam + '" — showing all available tickets below.';
      noteEl.hidden = false;
    }
  }
  apply();
})();

  } catch(e) { console.error(e); }
})();
})();
